import skillEdit from './edit.vue'
import skillList from './list.vue'
import * as skillcategoryList from './category'

let a = Object.assign({ skillEdit, skillList}, skillcategoryList)
export default a;